module.exports = __webpack_public_path__ + "static/img/BOSS.4d8d0bb7.png";